import type {
  ContextoAcessoCarregado,
  PermissaoUsuario,
  TipoUsuario,
} from './acesso.tipos'

const TIPOS_USUARIO: readonly TipoUsuario[] = ['all', 'group', 'mine']

const ehRegistro = (valor: unknown): valor is Record<string, unknown> => (
  typeof valor === 'object' && valor !== null && !Array.isArray(valor)
)

const exigirRegistro = (valor: unknown): Record<string, unknown> => {
  if (!ehRegistro(valor)) {
    throw new Error('Payload de acesso invalido')
  }
  return valor
}

const exigirTexto = (valor: unknown): string => {
  if (typeof valor !== 'string' || valor.length === 0) {
    throw new Error('Payload de acesso invalido')
  }
  return valor
}

const exigirId = (valor: unknown): string | number => {
  if ((typeof valor !== 'string' || valor.length === 0) && typeof valor !== 'number') {
    throw new Error('Payload de acesso invalido')
  }
  return valor
}

const exigirTipoUsuario = (valor: unknown): TipoUsuario => {
  if (typeof valor !== 'string' || !TIPOS_USUARIO.includes(valor as TipoUsuario)) {
    throw new Error('Payload de acesso invalido')
  }
  return valor as TipoUsuario
}

export const normalizarPermissoes = (roles: unknown): PermissaoUsuario[] => {
  if (!Array.isArray(roles)) {
    throw new Error('Payload de acesso invalido')
  }

  return roles.map((role) => {
    if (!Array.isArray(role)) {
      throw new Error('Payload de acesso invalido')
    }

    const nome = exigirTexto(role[0])
    const [modulo, acao, filtro] = nome.split('_')
    if (modulo === undefined || modulo.length === 0 || acao === undefined || acao.length === 0) {
      throw new Error('Payload de acesso invalido')
    }

    return filtro === undefined || filtro.length === 0
      ? { nome, modulo, acao }
      : { nome, modulo, acao, filtro }
  })
}

export const normalizarContextoAcesso = (payload: unknown): ContextoAcessoCarregado => {
  const bruto = exigirRegistro(payload)
  const roleGroup = exigirRegistro(bruto.roleGroup)
  const compMan = exigirRegistro(bruto.compMan)
  const email = exigirTexto(bruto.email)

  return {
    usuario: {
      id: exigirId(bruto.id),
      nome: exigirTexto(bruto.name),
      email,
      tipo: exigirTipoUsuario(roleGroup.kind),
      temCpf: typeof bruto.cpf === 'string' && bruto.cpf.length > 0,
      ehSuporte: bruto.ehDeSuporte === true || email.includes('lar21@'),
      acessoPorLideranca: Boolean(bruto.acessoPorLideranca),
    },
    empresa: {
      id: exigirId(compMan.id),
      nome: exigirTexto(compMan.name),
      portaria671: Boolean(compMan.portaria671),
      possuiInternacionalizacao: Boolean(compMan.hasInternacionalizacao),
      possuiPerfisDeAcesso: Boolean(compMan.possuiPerfisDeAcesso),
      possuiAcessoPorLideranca: Boolean(compMan.possuiAcessoPorLideranca),
    },
    permissoes: normalizarPermissoes(bruto.roles),
  }
}
